<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Q9nc9g/tc-custom/9781429989084.jpg?1740715145870" alt="This image is the cover for the book Running Away to Home"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Running Away to Home
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A middle class, Midwestern family in search of meaning uproot themselves and move to their ancestral village in Croatia.</b><br/><br/><i>"We can look at this in two ways," Jim wrote, always the pragmatist. "We can panic and scrap the whole idea. Or we can take this as a sign. They're saying the economy is going to get worse before it gets better. Maybe this is the kick in the pants we needed to do something completely different. There will always be an excuse not to go…"</i><br/><br/><i>And that, friends, is how a typically sane middle-aged mother decided to drag her family back to a forlorn mountain village in the backwoods of Croatia.</i><br/><br/>So begins author Jennifer Wilson's journey in <i>Running Away to Home</i>. Jen, her architect husband, Jim, and their two children had been living the typical soccer- and ballet-practice life in the most Middle American of places: Des Moines, Iowa. They overindulged themselves and their kids, and as a family they were losing one another in the rush of work, school, and activities. One day, Jen and her husband looked at each other–both holding their Starbucks coffee as they headed out to their SUV in the mall parking lot, while the kids complained about the inferiority of the toys they just got–and asked themselves: "Is this the American dream? Because if it is, it sort of sucks."<br/><br/>Jim and Jen had always dreamed of taking a family sabbatical in another country, so when they lost half their savings in the stock-market crash, it seemed like just a crazy enough time to do it. High on wanderlust, they left the troubled landscape of contemporary America for the Croatian mountain village of Mrkopalj, the land of Jennifer's ancestors. It was a village that seemed hermetically sealed for the last one hundred years, with a population of eight hundred (mostly drunken) residents and a herd of sheep milling around the post office. For several months they lived like locals, from milking the neighbor's cows to eating roasted pig on a spit to desperately seeking the village recipe for bootleg liquor. As the Wilson-Hoff family struggled to stay sane (and warm), what they found was much deeper and bigger than themselves.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennifer Wilson
      </h2>
      
      <p class="authorDescription body article">JENNIFER WILSON is an award-winning writer who has chronicled her travels, both epic and around the corner, in <I>National Geographic Traveler, Gourmet, Esquire, Midwest Living, Better Homes & Gardens, Frommer's Budget Travel, Parents</I>, and <I>Disney Family Fun. Running Away to Home</I> was awarded Best Nonfiction Book of 2011 by the American Society of Journalists and Authors.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a5b001aa